/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileLite,
    CaseFileLiteFromJSON,
    CaseFileLiteFromJSONTyped,
    CaseFileLiteToJSON,
    ResponsiveFile,
    ResponsiveFileFromJSON,
    ResponsiveFileFromJSONTyped,
    ResponsiveFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResponsiveFileMap
 */
export interface ResponsiveFileMap {
    /**
     * 
     * @type {{ [key: string]: Array<ResponsiveFile>; }}
     * @memberof ResponsiveFileMap
     */
    interrogatoryFileMap?: { [key: string]: Array<ResponsiveFile>; } | null;
    /**
     * 
     * @type {Array<CaseFileLite>}
     * @memberof ResponsiveFileMap
     */
    unusedFiles?: Array<CaseFileLite> | null;
}

export function ResponsiveFileMapFromJSON(json: any): ResponsiveFileMap {
    return ResponsiveFileMapFromJSONTyped(json, false);
}

export function ResponsiveFileMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsiveFileMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interrogatoryFileMap': !exists(json, 'interrogatoryFileMap') ? undefined : json['interrogatoryFileMap'],
        'unusedFiles': !exists(json, 'unusedFiles') ? undefined : (json['unusedFiles'] === null ? null : (json['unusedFiles'] as Array<any>).map(CaseFileLiteFromJSON)),
    };
}

export function ResponsiveFileMapToJSON(value?: ResponsiveFileMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interrogatoryFileMap': value.interrogatoryFileMap,
        'unusedFiles': value.unusedFiles === undefined ? undefined : (value.unusedFiles === null ? null : (value.unusedFiles as Array<any>).map(CaseFileLiteToJSON)),
    };
}


